import { Link } from "react-router-dom";
import { useParallax } from "hooks/useParallax";
import Reveal from "./Reveal";

interface PPVHeroProps {
  link: string;
  image: string;
}

const PPVHero = ({ link, image }: PPVHeroProps) => {
  const { ref: parallaxRef, offset } = useParallax<HTMLDivElement>(0.15);

  return (
    <div className="relative isolate mb-20 h-[560px] w-full overflow-hidden rounded-3xl max-sm:h-[520px] max-sm:rounded-2xl">
      <div
        ref={parallaxRef}
        className="absolute -inset-y-16 inset-x-0"
        style={{ transform: `translateY(${offset}px) scale(1.1)` }}
      >
        <img src={image} alt="" className="h-full w-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/75 to-black/45" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/10 to-transparent" />

      <div className="relative z-10 flex h-full flex-col items-center justify-center px-6 text-center">
        <Reveal>
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.06] px-4 py-1.5 text-[12px] font-semibold uppercase tracking-[0.14em] text-white/70 backdrop-blur-md">
            <span className="h-1.5 w-1.5 rounded-full bg-[var(--red)]" />
            AYOZAT for Creators
          </span>
        </Reveal>

        <Reveal delay={100}>
          <h1 className="mt-6 max-w-3xl text-[44px] font-extrabold leading-[1.08] tracking-tight text-white max-sm:text-[28px]">
            Turn your live events into a{" "}<br></br>
            <span className="text-[var(--red)]">Pay-Per-View</span> revenue
            stream
          </h1>
        </Reveal>

        <Reveal delay={200}>
          <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-white/70 max-sm:text-[14px]">
            Set your own price, keep full creative control, and get paid
            every time a fan tunes in — powered by AYOZAT's PPV platform.
          </p>
        </Reveal>

        <Reveal delay={300}>
          <Link to={link}>
            <button className="mt-8 rounded-full bg-[var(--red)] px-9 py-3.5 text-[15px] font-bold text-white shadow-lg shadow-[var(--red)]/30 transition-all duration-300 hover:scale-[1.03] hover:brightness-110 hover:shadow-xl">
              Explore Content
            </button>
          </Link>
        </Reveal>
      </div>
    </div>
  );
};

export default PPVHero;
